import { render, staticRenderFns } from "./LoadScript.vue?vue&type=template&id=13ea4f23"
import script from "./LoadScript.vue?vue&type=script&lang=js"
export * from "./LoadScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports